/** ラリー詳細のスポット絞り込み */

import type { StampRallyGroup, StampRallyItem } from '@/api/types/stamp-rally'

export const prefecturesOf = (groups: StampRallyGroup[]): string[] => {
  const found = new Set<string>()
  for (const group of groups) {
    for (const item of group.items) {
      if (item.prefecture) found.add(item.prefecture)
    }
  }
  return [...found].sort((a, b) => a.localeCompare(b, 'ja'))
}

/** 絞り込みに使う項目だけ。地図の RallyMapItem もそのまま渡せるようにする */
type Filterable = Pick<StampRallyItem, 'name' | 'address' | 'note' | 'prefecture'>

const matches = (item: Filterable, keyword: string, prefectures: string[]): boolean => {
  if (prefectures.length > 0 && (item.prefecture === null || !prefectures.includes(item.prefecture))) return false
  if (!keyword) return true
  const haystack = [item.name, item.address, item.note].filter(Boolean).join(' ').toLowerCase()
  return haystack.includes(keyword)
}

/** 同じ絞り込みを地図側へも掛けるための入口 */
export const matchesItemFilters = (item: Filterable, keyword: string, prefectures: string[]): boolean =>
  matches(item, keyword.trim().toLowerCase(), prefectures)

/** 空になったグループは畳んでも意味がないので落とす */
export const filterGroups = (groups: StampRallyGroup[], keyword: string, prefectures: string[]): StampRallyGroup[] => {
  const needle = keyword.trim().toLowerCase()
  if (!needle && prefectures.length === 0) return groups
  return groups
    .map((group) => ({ ...group, items: group.items.filter((item) => matches(item, needle, prefectures)) }))
    .filter((group) => group.items.length > 0)
}
